import { render, staticRenderFns } from "./MainMobileMenu.vue?vue&type=template&id=2568b7f9"
import script from "./MainMobileMenu.vue?vue&type=script&lang=js"
export * from "./MainMobileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports